import { NavLink } from "react-router-dom";
import styles from "./MainMenu.module.css";
import { useSiteInfo } from "../context/SiteContext";
import React from "react";

function MainMenu() {
  //const { banRooms } = useSiteInfo();
  const banRooms = JSON.parse(sessionStorage.getItem("banRooms"));
  const user = JSON.parse(localStorage.getItem("userLogin"));
  return (
    <>
      <ul className={styles.menuList}>
        <li>
          <NavLink to="/">Calendar</NavLink>
        </li>
        <li>
          <NavLink to="/customers">Customers</NavLink>
        </li>
        <li>
          <NavLink to="/reports">Reports</NavLink>
        </li>
        {console.log(user.isAdmin)}
        {user.isAdmin ? (
          <li>
            <NavLink to="/settings">Settings</NavLink>
          </li>
        ) : (
          ""
        )}
      </ul>
      <div className={styles.rooms}>
        <h3>Banquet Rooms</h3>
        <ul className={styles.roomList}>
          {banRooms.map((banRoom) => {
            if (user.location == 0 || user.location == banRoom.LocationID || banRoom.LocationID == 0)
              if (banRoom.LocationID != 3) {
                return (
                  <li style={{ backgroundColor: banRoom.Color }} className={styles.colorContrast} key={banRoom.idBanquetRooms}>
                    {banRoom.RoomName}
                  </li>
                );
              }
          })}
        </ul>
      </div>
    </>
  );
}

export default MainMenu;
